import Project from "../main.js";

export default class Navigation {
	constructor() {
		this.project = new Project();

		this.DOM = {
			header: this.project.DOM.body.querySelector('.header'),
			headerNavToggle: this.project.DOM.body.querySelector('.header__menu-toggle'),
			headerNav: this.project.DOM.body.querySelector('.header__nav'),
		}

		if(!this.DOM.header) {
			return null;
		}

		this.init();
	}

	init() {
		this.handleEvents()
	}

	getHeaderHeight() {
		return this.DOM.header.offsetHeight;
	}

	handleEvents() {
		this.DOM.headerNavToggle.addEventListener('click', e => {
			this.DOM.header.classList.toggle('header--nav-open');
		})

		this.project.hooks.resize.push(this.handleResize.bind(this))
	}

	handleResize() {
		this.project.DOM.body.style.setProperty('--header-height', `${this.getHeaderHeight()}px`);
	}
}